export var actionTypePrefix = '@@CommentEditor';
export var reduxKey = '@@CommentEditor';
//# sourceMappingURL=constants.js.map